import { getFeatureFlag } from "common/feature-flags";

let tryingToReload = false;

export function isTryingToReload(): boolean {
    return tryingToReload;
}

export function reloadBrowserWindow(...args: any[]): void {
    tryingToReload = true;
    if (getFeatureFlag("debugBrowserReload")) {
        // eslint-disable-next-line no-console
        console.trace("Reloading browser window", ...args);
        setTimeout(() => {
            debugger;
            window.location.reload();
        }, 10 * 1000);
        debugger;
    } else {
        window.location.reload();
    }
}
